import { memo } from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';

import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

interface ErpTextProps {
  showErp: boolean;
  onLogoClick: () => void;
  onToggleErp: (e: React.MouseEvent) => void;
}

const ErpText = ({ showErp, onLogoClick, onToggleErp }: ErpTextProps) => (
  <Stack
    direction="row"
    spacing={0.5}
    sx={{
      alignItems: 'center',
    }}
  >
    <Typography
      variant="subtitle1"
      sx={{
        fontWeight: 'bold',
        display: { xs: 'none', sm: 'block' },
        cursor: 'pointer',
      }}
      onClick={onLogoClick}
    >
      ERP
    </Typography>
    <IconButton onClick={onToggleErp} sx={{ p: 0, minWidth: 'auto', minHeight: 'auto' }}>
      <Iconify icon={showErp ? 'eva:arrow-up-fill' : 'eva:arrow-down-fill'} sx={{ width: 16, height: 16 }} />
    </IconButton>
  </Stack>
);

export default memo(ErpText);
